import { css } from '../styled';

/**
 * A mixin that provides a safe way to use dynamic viewport height.
 * Uses --dynamic-vh CSS variable if set, falls back to regular 100vh if not.
 */
export const vh = css`var(--dynamic-vh, 100vh)`;
